<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add
            class="col-12"
            v-if="isCreate()"
            :btnTitle="$t('production.rejection_motive')"
            @openModal="openModal"
          />
        </div>
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
          >
            <template slot="addColumns">
              <table-column-badges
                :label="$t('common_words.associated_crops')"
                fromData="crops"
                textBadge="name"
              />
              <table-column-badges
                prop="business_names[0]"
                :label="$t('common_words.associated_companies2')"
                fromData="business_names"
                :isObject="false"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="110"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <export-tables
          :pdf="{
            filename: `${$t('production.rejection_motive')}.pdf`,

            route: 'rejecteds/causes/pdf',
          }"
          :xls="{
            filename: `${$t('production.rejection_motive')}.xlsx`,
            route: 'rejecteds/causes/excel',
          }"
        />
        <br />
      </card>
      <el-dialog
        width="60%"
        :title="title"
        :visible.sync="modals.create"
        :close-on-click-modal="false"
      >
        <form>
          <div class="row">
            <div class="col-12">
              <fg-input
                ref="nombre"
                type="text"
                name="common_words.name"
                v-model="causeRejectedForm.name"
                v-validate="modelValidations.name"
                :label="`${$t('common_words.name')}: *`"
                :error="getError('common_words.name', true)"
                :placeholder="$t('production.motive_of')"
              >
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group has-label">
                <label class="text-transform-none"
                  >{{ $t('common_words.select_companies') }}: *</label
                >
                <br />
                <el-select
                  @change="
                    selectAllFromSelect(
                      'causeRejectedForm.business_ids',
                      businesses
                    )
                  "
                  clearable
                  filterable
                  multiple
                  class="select-primary custom-width-select required-business_ids shadow-sm"
                  size="large"
                  v-model="causeRejectedForm.business_ids"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="business in businesses"
                    class="select-primary selected-all"
                    :value="business.id"
                    :label="business.name"
                    :key="business.id + business.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="row">
            <select-component
              modelName="crop_ids"
              :rowClass="`col-12`"
              :requireClass="`required-crop_ids`"
              :labelSelect="`${$t('common_words.select_crops')}: *`"
              :dataOptions="crops"
              :initialSelection="causeRejectedForm.crop_ids"
              @onChange="handleChangeSelected"
            />
          </div>
        </form>
        <span slot="footer" class="dialog-footer">
          <button
            class="btn btn-danger custom-shadow-btn"
            @click="closeModal('create')"
          >
            {{ $t('common_words.cancel') }}</button
          >&nbsp;
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="validate"
          >
            {{ $t('common_words.save') }}
          </button>
        </span>
      </el-dialog>
      <el-dialog
        width="60%"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        :close-on-click-modal="false"
      >
        <div class="card" v-if="rowData">
          <div class="card-body" v-if="rowData">
            <table class="table">
              <tbody>
                <tr class="shadow-sm">
                  <td>
                    <h6>
                      <strong>{{ $t('common_words.name') }}:</strong>
                    </h6>
                    {{ rowData.name }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="custom-margin-h6-table">
                      <strong
                        >{{ $t('common_words.associated_companies') }}:</strong
                      >
                    </h6>
                    <span
                      v-for="(business, index) in rowData.business_names"
                      :key="index"
                    >
                      <el-tag type="info">{{ business }}</el-tag>
                    </span>
                    <el-tag
                      type="warning"
                      v-if="
                        !rowData.business_names ||
                        rowData.business_names.length == 0
                      "
                      >{{ $t('common_words.no_associated_companies') }}</el-tag
                    >
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="custom-margin-h6-table">
                      <strong
                        >{{ $t('common_words.associated_crops') }}:</strong
                      >
                    </h6>
                    <span v-for="(item, index) in rowData.crops" :key="index">
                      <el-tag type="info">{{ item.name }}</el-tag>
                    </span>
                    <el-tag
                      type="warning"
                      v-if="!rowData.crops || rowData.crops.length == 0"
                      >{{ $t('common_words.no_associated_crops') }}</el-tag
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at">
            <p class="text-muted">
              <small
                >{{ $t('common_words.created_on') }}:
                {{ rowData.created_at }}</small
              >
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './causeRejectedsTable';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().Search,

    nameCauseRejectedSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },
  data() {
    return {
      causeRejectedForm: {
        name: null,
        business_ids: [],
        crop_ids: [],
        user_id: this.$store.state.auth.user.id,
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
      title: null,
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        create: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      businesses: [],
      crops: [],
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },

    handleChangeSelected(data) {
      this.$set(this.causeRejectedForm, data.name, data.selects);
    },

    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('common_words.create_new_record');
        this.$validator.reset();
        this.causeRejectedForm = {
          name: null,
          business_ids: [],
          crop_ids: [],
          user_id: this.$store.state.auth.user.id,
        };

        this.causeRejectedForm.business_ids = this.selectElementsAsignFromModel(
          1,
          this.causeRejectedForm.business_ids,
          this.businesses
        );
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (!isValid) return;

        const requiredFields = [
          { key: 'business_ids', label: 'business_ids' },
          { key: 'crop_ids', label: 'crop_ids' },
        ];

        const missingField = requiredFields.find(
          ({ key }) => !isset(this.causeRejectedForm[key])
        );

        if (missingField) {
          return this.validationInputsRequired(missingField.label);
        }

        this.addEditCauseRejected();
      });
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      this.modals['create'] = true;
      this.title = i18n.t('common_words.edit_selected_record');
      this.causeRejectedForm = Object.assign({}, row);
      this.causeRejectedForm.business_ids = [...new Set(row.business_ids)];

      if (isset(row.crops)) {
        this.causeRejectedForm.crop_ids = [
          ...new Set(row.crops.map((item) => item.id)),
        ];
      }

      this.causeRejectedForm.route = 'rejecteds/causes';
      this.errors.clear();
    },

    handleDelete(_, row) {
      this.causeRejectedForm = row;
      SweetAlert.delete(
        `${i18n.t('production.the_rejection_motive')} ${
          this.causeRejectedForm.name
        }`
      ).then((result) => {
        if (result.value) this.deleteCauseRejected();
      });
    },

    handleActivate(_, row) {
      this.causeRejectedForm = row;
      SweetAlert.default(
        `¿${i18n.t('sweet_alert.production.activate_unit')} "${
          this.causeRejectedForm.name
        }"?`,
        null,
        i18n.t('sweet_alert.station.accept'),
        1
      ).then((result) => {
        if (result.value) this.activateCauseRejected();
      });
    },

    activateCauseRejected() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.causeRejectedForm.route = 'rejecteds/causes/activate';
        Axios.updateMaster(this.causeRejectedForm)
          .then((response) =>
            this.modifyTable(1, this.causeRejectedForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    addEditCauseRejected() {
      this.showHideLoading(true);
      if (this.causeRejectedForm.route == 'rejecteds/causes') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.causeRejectedForm)
            .then((response) => {
              this.modifyTable(1, this.causeRejectedForm.id, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.causeRejectedForm.route = 'rejecteds/causes';
          Axios.saveMaster(this.causeRejectedForm)
            .then((response) => {
              this.modifyTable(0, null, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deleteCauseRejected() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.causeRejectedForm.route = 'rejecteds/causes';
        Axios.destroyMaster(this.causeRejectedForm)
          .then((response) =>
            this.modifyTable(1, this.causeRejectedForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('rejecteds/causes')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns
              .map((prop) => {
                return prop.prop;
              })
              .concat(['business_names']),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('businesses/only').then((response) => {
      this.businesses = this.concatAll(response.data.data);
      this.showHideLoading();
    });

    Axios.getMasters('farms/crops').then((response) => {
      this.crops = this.concatAll(response.data.data);
      this.showHideLoading();
    });
  },

  mounted() {
    this.selectedItemOnMenu('rejecteds');
  },

  destroyed() {
    this.deselectedItemOnMenu('rejecteds');
  },
};
</script>
<style></style>
